"use client";

import React from "react";
import { ChevronsRight, Map, Globe } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GeospatialHeroComparison() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: orbitalRef,
    isVisible: orbitalVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: topRef,
    isVisible: topVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: midRef,
    isVisible: midVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: botRef,
    isVisible: botVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="geospatialherocomparison" className="bg-background w-full flex flex-col">
      
      {/* Hero Block with Fixed Scrolling Background */}
      

      {/* NEW: Orbital Intelligence Section */}
      <div className="w-full bg-[#0a0f1c] relative overflow-hidden border-b border-zinc-800">
        {/* Subtle Background Grid (Optional, matches the image aesthetic) */}
        <div className="absolute inset-0 !bg-[rgba(22,18,48,0)] !h-[700px]"></div>

        <div ref={orbitalRef} className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 gap-12 items-center transition-all duration-1000 opacity-100 translate-y-0 !h-[700px] ![padding:0px_16px_0px_16px] lg:grid-cols-2">
          
          {/* Left Side: Graphic Placeholder */}
          <div className="relative w-full aspect-square md:aspect-video lg:aspect-square flex justify-center items-center">
            {/* Replace this src with the actual exported globe/satellite asset */}
            <img src="https://via.placeholder.com/600x600/0a0f1c/ffffff?text=Orbital+Graphic+Here" alt="Orbital Intelligence View" className="w-full h-full object-contain drop-shadow-2xl" src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image106.gif" />
          </div>

          {/* Right Side: Text Content */}
          <div className="flex flex-col justify-center">
            {/* Green Badge */}
 <div className="inline-flex items-center gap-2 border border-[#00d2ff] rounded-full px-4 py-1.5 text-white font-semibold text-xs tracking-widest uppercase mb-6 w-max bg-[#22c55e]/10">         
  <Map className="w-4 h-4 text-[#00d2ff]" />
   <span>ՔԱՐՏԵԶԱԳՐՈՒՄ ԵՎ ԹՎԱՅՆԱՑՈՒՄ</span>
            </div>

            {/* Main Heading */}
            <h2 className="text-4xl font-bold text-white leading-tight tracking-tight mb-8 font-default !w-[700px] md:text-5xl lg:text-6xl">Թվային քարտեզների ստեղծում և թարմացում</h2>

            {/* Description Text */}
            <p className="text-zinc-300 text-base md:text-lg leading-relaxed mb-8">Առաջադեմ քարտեզագրական լուծումներով մենք իրականացնում ենք թվային քարտեզների գերճշգրիտ ստեղծում և արդիականացում՝ ապահովելով հուսալի տարածական տվյալներ ենթակառուցվածքների զարգացման, ռեսուրսների կառավարման և տարածքային պլանավորման համար</p>

            {/* Quote / Sub-description */}
            
          </div>
        </div>
      </div>

      {/* Existing Content Blocks */}
      

      <div className="w-full py-16 border-y border-zinc-800 !bg-[rgba(255,255,255,1)] md:py-20">
        <div ref={midRef} className={`max-w-4xl mx-auto px-4 text-center transition-all duration-1000 delay-200 ${midVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <p className="font-serif text-lg leading-relaxed md:text-xl lg:text-2xl text-secondary-foreground">
            Վերջին տվյալներով արբանյակային պատկերների միջոցով մենք ստեղծում և թարմացնում ենք տարբեր մասշտաբների թվային քարտեզներ: Բացի այդ, մենք առաջարկում ենք քարտեզների թվայնացման, պատրաստման և տպագրության ծառայություններ՝ ապահովելով ճշգրտություն և արդյունավետություն Ձեր նախագծերի համար:
          </p>
        </div>
      </div>

      <div className="w-full py-20 !bg-[rgba(21,16,40,1)] md:py-32">
        <div ref={botRef} className={`max-w-6xl mx-auto px-4 transition-all duration-1000 delay-300 ${botVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="bg-slate-950 rounded-2xl p-8 md:p-12 border border-slate-800 shadow-2xl shadow-black/50">
            <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-12 font-default tracking-wide">Թվային քարտեզագրման ծառայություններ</h2>
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 lg:gap-16">
              
              <div className="flex-1 w-full max-w-md flex flex-col items-center">
                <h3 className="text-zinc-300 text-center mb-4 font-default !font-semibold !text-lg">Արբանյակային պանխրոմատիկ պատկեր</h3>
                <div className="w-full border-2 border-[#00d2ff] p-1.5 rounded-xl bg-black/50 shadow-lg">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/satellite_panchromatic_raw.png" alt="Raw Satellite Image" className="w-full h-auto rounded-lg object-cover aspect-[4/3]" loading="lazy" src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image277.jpeg" src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image47.jpeg" />
                </div>
              </div>

              <div className="flex-shrink-0 py-4 md:py-0">
                <ChevronsRight className="w-16 h-16 md:w-24 md:h-24 text-[#00d2ff] opacity-80" />
              </div>

              <div className="flex-1 w-full max-w-md flex flex-col items-center">
                <h3 className="text-zinc-300 text-center mb-4 font-default !font-semibold !text-lg">Տեղագրական քարտեզ</h3>
                <div className="w-full border-2 border-[#00d2ff] p-1.5 rounded-xl bg-black/50 shadow-lg">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/topographic_map_processed.png" alt="Processed Topographic Map" className="w-full h-auto rounded-lg object-cover aspect-[4/3]" loading="lazy" src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image313.png" src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image48.jpeg" />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>;
}